import { render } from "./listPenitentiary.vue?vue&type=template&id=72047a6a"
import script from "./listPenitentiary.vue?vue&type=script&lang=js"
export * from "./listPenitentiary.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__